const PUNCTUATION_MARKS: string[] = ['-',',','.','_','/',':',';'];

export const customWordBreak = (text: string): string => {
    return PUNCTUATION_MARKS.reduce((accumulator,value)=>accumulator.replaceAll(value, value+" "),text);
}